import { Delete, Get, Patch, Post, Put } from '../../api/axiosCoreConfig';

// export const getClinics = (polyclinicId) => {
//     Get(`/clinic${polyclinicId ? `?polyclinic_id=${polyclinicId}` : ''}`);
// };
export const getPolyclinics = () => Get('/polyclinic');
export const reauthorize = (refresh) => Post('/user/auth/refresh', refresh);
export const logout = (refresh) => Post('/user/auth/logout', refresh);
export const getUserInfo = () => Get('/user/info');
export const login = (credential) => Post(`/user/auth/login`, credential);
export const createUser = (userProfile) => Post(`/user`, userProfile);
export const getUsers = (namespace) => Get(`/user?namespace=${namespace}`);
export const getUser = (userId, namespace) => Get(`/user/${userId}?namespace=${namespace}`);
export const findUser = (username, namespace) =>
    Get(`/user/find/username/${username}?namespace=${namespace}`);
export const editUserAccess = (userId, value) => Patch(`/user/${userId}/access`, value);
export const deleteUser = (namespace, userId) => Delete(`/user/${userId}/namespace/${namespace}`);
export const updateUserInfo = (userInfo) => Put('/user/profile', userInfo);
export const changePassword = (credentials) => Put('/user/change_password', credentials);
